import styles from './index.less';
import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '@src/layout-components/page';
import aos from '@src/utils/aos';
import ActivityHeader from './components/activity-header';
import EventOverview from './components/event-overview';
import GuildAssembly from './components/guild-assembly';
import WorldCompetition from './components/world-competition';
import MatchRewards from './components/match-rewards';

const MAIN_MODULES = [{ id: 0, title: '赛事概览' }, { id: 1, title: '帮会集结' }, { id: 2, title: '逐鹿天下' }, { id: 3, title: '比赛奖励' }];

const Main = () => {
  const store = useStore(() => new MainStore());
  const activityContent = store.activityContent;

  React.useEffect(() => {
    aos.init();
  }, []);

  React.useEffect(
    () => {
      aos.refreshHard();
    },
    [activityContent, store.activeTab]
  );

  const renderModule = moduleId => {
    if (moduleId === 0) {
      return <EventOverview content={activityContent} matchBracketStore={store.matchBracketStore} />;
    }
    if (moduleId === 1) {
      return <GuildAssembly content={activityContent} />;
    }
    if (moduleId === 2) {
      return <WorldCompetition content={activityContent} />;
    }
    return <MatchRewards content={activityContent} />;
  };

  return (
    <Page className={styles.root}>
      <div className={styles.heroBackground} aria-hidden="true" />
      <div className={styles.scheduleSection} aria-hidden="true" />
      <ActivityHeader activeTab={store.activeTab} onTabChange={store.setActiveTab} sloganUrl={activityContent ? activityContent.sloganUrl : ''} />
      <main className={styles.modulePanels}>
        {activityContent ? (
          MAIN_MODULES.map(module => {
            const isActive = store.activeTab === module.id;

            return (
              <section
                className={styles.modulePanel}
                id={`main-panel-${module.id}`}
                role="tabpanel"
                aria-label={module.title}
                hidden={!isActive}
                key={module.id}
              >
                {renderModule(module.id)}
              </section>
            );
          })
        ) : (
          <div className={styles.contentStatus}>{store.activityContentStatus === 'error' ? '活动内容加载失败，请刷新后重试。' : '活动内容加载中...'}</div>
        )}
      </main>
    </Page>
  );
};

export default observer(Main);
